import { z } from "zod";

export enum SideRibType {
  NONE = "NONE",
  UP = "UP",
  DOWN = "DOWN",
  BOTH = "BOTH",
}
export const sideRibTypeSchema = z.nativeEnum(SideRibType);
